import React from 'react';
import clsx from 'clsx';
import { sanitize } from '@americanexpress/consumer-travel-base';
import styles from './BenefitCards.scss';
import BenefitCard from './BenefitCard';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const BenefitCards = () => {
  const orBadge = useDataFromOneCMS('benefitCardsSection.orBadge');
  const finePrint = useDataFromOneCMS('benefitCardsSection.finePrint');
  const fhrBenefitCard = useDataFromOneCMS('benefitCardsSection.fhrBenefitCard');
  const thcBenefitCard = useDataFromOneCMS('benefitCardsSection.thcBenefitCard');

  const fhrBenefitCount = fhrBenefitCard.benefits.filter((benefit) => benefit.displayed).length;
  const thcBenefitCount = thcBenefitCard.benefits.filter((benefit) => benefit.displayed).length;
  const largestBenefitCount = Math.max(fhrBenefitCount, thcBenefitCount);

  return (
    <div>
      <div className="container width-full color-graphic-brand-logo-blue-box-text">
        <div
          className={clsx('flex flex-align-items-center flex-column-sm-down margin-3-lr-sm-down', styles.badgeWrapper)}
        >
          <BenefitCard
            benefitType="FHR"
            content={fhrBenefitCard}
            extraPaddingRequired={largestBenefitCount - fhrBenefitCount}
          />
          <div className={clsx(styles.orBadge, 'flex flex-align-center flex-justify-center dls-bright-blue-bg')}>
            <span>{orBadge}</span>
          </div>
          <BenefitCard
            benefitType="THC"
            content={thcBenefitCard}
            extraPaddingRequired={largestBenefitCount - thcBenefitCount}
          />
        </div>
        <div
          className={clsx(styles.textTransform, 'dls-gray-05 text-align-center label-1 margin-1-t margin-0-b', styles.textWrapper)}
          /* eslint-disable-next-line react/no-danger -- content from oneCMS */
          dangerouslySetInnerHTML={{ __html: sanitize(finePrint, { html: true }) }}
        />
      </div>
    </div>
  );
};

export default BenefitCards;
